import React from 'react';
export function Footer() {
  return <footer className="bg-[#0f1d30] text-gray-400 py-8 text-center border-t border-white/10" data-id="element-38">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-39">
        <p className="text-sm" data-id="element-40">
          © 2026 Sistema PRO: Cero Persecución. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}